import { ArrowRight, ChevronDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { IMAGES } from '../mock';
import { useLang } from '../i18n/LanguageContext';

export default function Hero({ onGetInTouch }) {
  const { t } = useLang();
  const subParts = t('hero.subtitle').split('{highlight}');
  return (
    <section id="accueil" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={IMAGES.hero} alt="Port" className="w-full h-full object-cover" />
        <div className="absolute inset-0 hero-overlay" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 w-full text-center pt-24 pb-16">
        <div className="fade-in">
          <span data-testid="home-founded-year" className="inline-block text-brand-yellow text-xs md:text-sm font-semibold tracking-[0.35em] uppercase mb-6 border border-brand-yellow/40 px-4 py-2 rounded-full bg-brand-yellow/10">
            {t('hero.badge')}
          </span>

          <h1 className="font-black leading-[0.95] mb-4">
            <span className="block text-brand-yellow text-6xl md:text-8xl lg:text-9xl tracking-tight">YUVILLE</span>
            <span className="block text-white text-3xl md:text-5xl lg:text-6xl font-light tracking-wide mt-2">INTERNATIONAL inc.</span>
          </h1>

          <p className="text-white/90 text-base md:text-lg lg:text-xl max-w-3xl mx-auto mt-8 leading-relaxed font-light">
            {subParts[0]}<span className="text-brand-yellow font-medium">{t('hero.highlight')}</span>{subParts[1]}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
            <button onClick={onGetInTouch} className="btn-yellow">
              {t('cta.getInTouch')} <ArrowRight className="w-4 h-4" />
            </button>
            <a href="#trading" className="btn-outline-white">{t('cta.discover')}</a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto mt-16">
            <Link to="/trading" className="group text-left bg-white/5 backdrop-blur-md border border-white/15 hover:border-brand-yellow/60 rounded-lg p-6 transition-all hover-lift">
              <div className="text-brand-yellow text-xs font-bold tracking-widest uppercase mb-2">{t('hero.service1Tag')}</div>
              <div className="text-white text-2xl font-bold mb-2">{t('hero.service1Title')}</div>
              <div className="text-white/70 text-sm">{t('hero.service1Desc')}</div>
              <div className="flex items-center gap-2 text-brand-yellow text-sm font-semibold mt-4 group-hover:gap-3 transition-all">
                {t('hero.discover')} <ArrowRight className="w-4 h-4" />
              </div>
            </Link>
            <a href="#plateforme" className="group text-left bg-white/5 backdrop-blur-md border border-white/15 hover:border-brand-yellow/60 rounded-lg p-6 transition-all hover-lift">
              <div className="text-brand-yellow text-xs font-bold tracking-widest uppercase mb-2">{t('hero.service2Tag')}</div>
              <div className="text-white text-2xl font-bold mb-2">{t('hero.service2Title')}</div>
              <div className="text-white/70 text-sm">{t('hero.service2Desc')}</div>
              <div className="flex items-center gap-2 text-brand-yellow text-sm font-semibold mt-4 group-hover:gap-3 transition-all">
                {t('hero.explore')} <ArrowRight className="w-4 h-4" />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6 text-white/70" />
      </div>
    </section>
  );
}
